function onAjaxSuccess(data, status, xhr) {
    $.get(this.dataset.territoryUrl + "?businessSubTypeId=" + this.value, function (data) {
        buildDropdown(data, "ServiceTypeIds", false);
        let $territorySection = $("#territory-section");
        if (data.length === 0) {
            $territorySection.addClass("d-none");
        } else {
            $territorySection.removeClass("d-none");
        }

        resetTerritory();
        $('#service-territories')["html"]("");
    });
    resetValidation($(this).parents('form'));
}

$(document).on('change', '[toggleServicesAndTerritoriesAddButton]', function (event) {
    
    toggleServicesAndTerritoriesAddButton();
});

function toggleServicesAndTerritoriesAddButton() {
    var isDisabled = $(".add-services select").valid();
    if ($("input[id='ZipCodes']") != undefined && $("input[id='ZipCodes']").val() == '') {
        isDisabled = false;
    }
    $(".add-services div").removeClass("has-error");
    $('#btnAddServicesAndTerritories').prop('disabled', !isDisabled);
}

function resetValidation($form) {
    $form.removeData('unobtrusiveValidation validator');
    $.validator.unobtrusive.parse($form);
}

function onStateChangeSuccess(data, status, xhr) {
    buildDropdown(data, "CountyIds", false);
    resetValidation($(this).parents('form'));
    toggleServicesAndTerritoriesAddButton();
}

function onServiceLevelChangeSuccess(data, status, xhr) {
    resetValidation($(this).parents('form'));
    toggleServicesAndTerritoriesAddButton();
}

function buildDropdown(data, dropDownId, includeDefault = true, selectedValue) {
    var select = $('#' + dropDownId);
    if (select) {
        select.empty();
        select.selectpicker('refresh');
    }
    if (data) {
        var optionStr = "";
        if (includeDefault) {
            optionStr += "<option value>...</option>";
        }

        $.each(data, function (index) {
            if (this.subtext && this.subtext.toLowerCase() !== this.text.toLowerCase()) {
                optionStr += "<option data-content=\"<span>"
                    + this.text + " <small class='text-muted display-block'>"
                    + this.subtext +
                    "</small></span>\" title=\"" + this.text + "\" value="
                    + this.value + (this.value === selectedValue ? " selected" : "") + ">" +
                    this.text + "</option>";
            }
            else {
                optionStr += "<option value=" + this.value + (this.value === selectedValue ? " selected" : "") + ">" + this.text + "</option>";
            }
        });
        select.append(optionStr);
        select.selectpicker('refresh');
    }
}

function LoadTerritory() {

    if ($(".add-services select,input[id='ZipCodes']").valid()) {
        var model = {
            serviceTypeIds: $('#ServiceTypeIds').val(),
            serviceType: $('#ServiceTypeIds').find('option:selected').text(),
            serviceAtLevel: $('#ServiceAtLevel').val(),
            stateIds: $("#StateIds").val(),
            countyIds: $("#CountyIds").val(),
            zipCodes: $("#ZipCodes").val() ? $("#ZipCodes").val().split(',') : null
        }

        var surveyForm = $('#add-survey');
        var token = $('input[name="__RequestVerificationToken"]', surveyForm).val();
        $.ajax({
            type: 'POST',
            data: {
                __RequestVerificationToken: token,
                model
            },
            url: '/Survey/AddServiceAndTerritories',
            contentType: 'application/x-www-form-urlencoded',
            success: function (data) {
                $('#service-territories').text(data);
                $('#service-territories').html($('#service-territories').text());
                resetTerritory();
            }
        })
    }
}

function resetTerritory() {
    $("#ServiceAtLevel").val('default').selectpicker("refresh").trigger('change');
    $("#ServiceTypeIds").val('default').selectpicker("refresh");
    
    toggleServicesAndTerritoriesAddButton();
}

function ignoreOnSubmit() {
    var $form = $('#add-survey');
    var $elements = $(".ignore-on-submit");
    try {
        $elements.addClass("ignore");
        resetValidation($form);
        unhighlightElements($elements);
        setTimeout(function name() {
            $elements.removeClass("ignore");
            unhighlightElements($elements);
            resetValidation($form);
        }, 10);
    }
    catch (err) {
        $elements.removeClass("ignore");
        unhighlightElements($elements);
        resetValidation($form);
    }

    return true;
}

function unhighlightElements(elements) {
    $.each(elements, function (index) {
        unhighlight(this);
    });
}

function unhighlight(element) {
    const $element = $(element),
        $formGroup = $element.closest('.form-group');
    let hasError = $formGroup.data('has-error');

    if (hasError === undefined) {
        hasError = {};
        $formGroup.find('input[data-val=true],textarea[data-val=true],select[data-val=true]').each(function () {
            hasError[$(this).attr('id')] = false;
        });
    }

    hasError[$element.attr('id')] = false;
    $formGroup.data('has-error', hasError);

    let isAllValid = true;
    for (let key in hasError) {
        if (hasError.hasOwnProperty(key) && hasError[key]) {
            isAllValid = false;
            break;
        }
    }

    if (isAllValid) {
        $formGroup.removeClass('has-error');
    }
}

function confirmDeleteActionCallback(button, confirm) {
    var $button = $(button);
    if (!confirm) {
        return;
    }
    var surveyForm = $('#add-survey');
    var token = $('input[name="__RequestVerificationToken"]', surveyForm).val();
    $.post({
        data: {
            __RequestVerificationToken: token
        },
        url: $button.attr('href'),
        success: function (data) {
            $('#service-territories').text(data);
            $('#service-territories').html($('#service-territories').text());
            $("#ServiceAtLevel").val('default').selectpicker("refresh").trigger('change');
        }
    });
}

function onCellOtpResendSuccess(data) {
    if (data.otpRequestCrossedMessage != null && data.otpRequestCrossedMessage != undefined) {
        alert(data.otpRequestCrossedMessage);
        window.location.href = '/';
    }
    else if (data == true) {
        $('#VerificationCode').val('');
        $('#successMsg').html('We have sent a verification code to your cell phone number.').show();
        $('#failedMsg').hide();
    } else {
        $('#successMsg').hide();
        $('#failedMsg').show().html('Something went Wrong!');
    }
}


function onEmailOtpResendSuccess(data) {

    if (data.otpRequestCrossedMessage != null && data.otpRequestCrossedMessage != undefined) {
        alert(data.otpRequestCrossedMessage);
        window.location.href = '/';
    }
    else if (data == true) {
        $('#VerificationCode').val('');
        $('#successMsg').html('We have sent a verification code to your email address.').show();
        $('#failedMsg').hide();
    } else {
        $('#successMsg').hide();
        $('#failedMsg').show().html('Something went Wrong!');
    }
}

function onFormSubmitSuccess(data) {
    if (data != null && data.redirectToUrl != null) {
        window.location = data.redirectToUrl;
    }
    else {
        $('#mdlValidateTaxIdSSN').modal('show')
    }
}

function onTaxIdSSNValidtion(data) {
    ignoreOnSubmit();
    var msg = $("#vrmSupportMessage");
    if (data != null && data.duplicateBusinessCode != null) {
        $(msg.find(".vrm-guid-code")).html("<code class='copy-to-clipboard text-bold'>" + data.duplicateBusinessCode + "</code><i class='fa fa-clipboard' aria-hidden='true' style='cursor: pointer' onclick='onCopyToClipboard(this)'></i>");
        var vrmEmail = $(".dupVendorVrmEmail");
        vrmEmail.attr("href", data.duplicateVendorVrmEmail);
        vrmEmail.text(data.duplicateVendorVrmEmail);
        msg.show();
    }
    if (data != null && data.redirectToUrl != null) {
        window.location = data.redirectToUrl;
    }
}

function onCopyToClipboard(e) {
    var $this = $(e);
    var element = $(".copy-to-clipboard");
    navigator.clipboard.writeText(element.text());
    $this.removeClass("fa fa-clipboard").addClass("fa fa-check");
    element.addClass("bg-grey-400");
    setTimeout(function () {
        $this.removeClass("fa fa-check").addClass("fa fa-clipboard");
        element.removeClass("bg-grey-400");
    }, 1000);
}

function IsVerifiedCellphoneChange() {
    if ($("#CellNumber").valid()) {
        $.ajax({
            type: 'Get',
            url: '/Survey/IsVerifiedCellphoneChange?cellphone=' + $("#CellNumber").val(),
            contentType: 'application/x-www-form-urlencoded; charset=UTF-8', // when we use .serialize() this generates the data in query string format. this needs the default contentType (default content type is: contentType: 'application/x-www-form-urlencoded; charset=UTF-8') so it is optional, you can remove it
            success: function (result) {
                if (result)
                    showCellPhoneVerificationMsg();
                else
                    hideCellPhoneVerificationMsg();
            },
            global: false
        })
    } else {
        hideCellPhoneVerificationMsg();
    }
}

function showCellPhoneVerificationMsg() {
    $('#verificationSuccessMsg').show();
    $('#btn-verify-cellphone').prop('disabled', true);
}

function hideCellPhoneVerificationMsg() {
    $('#verificationSuccessMsg').hide();
    $('#btn-verify-cellphone').prop('disabled', false);
}

function showEmailVerificationMsg() {
    $('#emailVerificationSuccessMsg').show();
    $('#btn-verify-email').prop('disabled', true);
}

function hideEmailVerificationMsg() {
    $('#emailVerificationSuccessMsg').hide();
    $('#btn-verify-email').prop('disabled', false);
}

function GetCountiesByCityState(selectedValue) {
    var state = $("#Business_StateId").val();
    $("#Business_CountyId").val('default').selectpicker("refresh");
    if (!state) {
        $("#Business_CountyId").empty().selectpicker("refresh");
    }
    else if (state && selectedValue.value.length > 0) {
        $('#countydiv').load('/Survey/GetCountiesByCityState?state=' + state + '&city=' + encodeURIComponent($("#Business_City").val()));
    }
}

function IsVerifiedEmailChange() {
    if ($("#EmailAddress").valid()) {
        $.ajax({
            type: 'Get',
            url: '/Survey/IsVerifiedEmailChange?emailAddress=' + $("#EmailAddress").val(),
            contentType: 'application/x-www-form-urlencoded; charset=UTF-8', // when we use .serialize() this generates the data in query string format. this needs the default contentType (default content type is: contentType: 'application/x-www-form-urlencoded; charset=UTF-8') so it is optional, you can remove it
            success: function (result) {
                if (result)
                    showEmailVerificationMsg();
                else
                    hideEmailVerificationMsg();
            },
            global: false
        })
    } else {
        hideEmailVerificationMsg();
    }
}


function onReCaptchaSubmit(token) {
    document.getElementById("ReCaptchaToken").value = token;
}
function onReCaptchaReset() {
    document.getElementById("ReCaptchaToken").value = null;
}

function loadOTPScreen() {

    $('#otpVerificationModal').modal('show');

    if ($('#IsEmailVerified').val() == 'False' && $('#IsCellNumberVerified').val() == 'False') {
        $('#successMsg').html('We have sent a verification code to your email address and cell phone number.').show();
    }
    else if ($('#IsEmailVerified').val() == 'False') {
        $('#successMsg').html('We have sent a verification code to your email address.').show();
    }
    else {
        $('#successMsg').html('We have sent a verification code to your cell phone number.').show();
    }

    $('#failedMsg').hide();

}

function onIdentityOtpVerifySuccess(data) {

    if (data.identityVerificationStatusViewModel != null && data.identityVerificationStatusViewModel != undefined && data.identityVerificationStatusViewModel.errorMessage != null && data.identityVerificationStatusViewModel.errorMessage != undefined) {
        $('#successMsg').hide();
        $('#failedMsg').show().html(data.identityVerificationStatusViewModel.errorMessage);
        if (data.identityVerificationStatusViewModel.statusCode != null && data.identityVerificationStatusViewModel.statusCode != undefined) {
            if (data.identityVerificationStatusViewModel.statusCode == 'InvalidEmailOtp') {
                $('#btnCellOTPVerificationSuccess').hide();
                $('#cellNumberverificationSuccessMsg').show();
                $('#verificationSuccessMsg').show();
                $('#txtCellNumberOTP').hide();

            }
            if ((data.identityVerificationStatusViewModel.statusCode == 'InvalidCellNumberOTP') || (data.identityVerificationStatusViewModel.statusCode == 'CellNumberOTPExpired')) {
                $('#btnEmailOTPVerificationSuccess').hide();
                $('#emailVerificationSuccessMessage').show();
                $('#emailVerificationSuccessMsg').show();
                $('#txtEmailOTP').hide();

            }
        }
    }
    else {
        $('#VerifiedEmailAddress').val($('#EmailAddress').val());
        $('#VerifiedCellNumber').val($('#CellNumber').val());
        $('#survey-form').html(data);
        $("body").removeClass("modal-open")
        $("div").removeClass("modal-backdrop fade in");
    }
}

function fnTogglePasswordField() {
    var el = $(".toggle-password");
    el.toggleClass(el.data("toggle-class"));
    var input = $(el.data("toggle-field"));
    if (input.attr("type") == "password") {
        input.attr("type", "text");
    } else {
        input.attr("type", "password");
    }
}




